module.exports = __webpack_public_path__ + "img/photo-0075.ac7c8755.jpg";